"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossUpload = require("@/utils/ossUpload");
var _otherH5Page = require("@/api/otherH5Page");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AddDialog',
  components: {},
  data: function data() {
    return {
      id: '',
      openType: '',
      dialogVisible1: false,
      title: '',
      ruleForm: {
        platformCode: 'OT',
        name: '',
        radio: 1,
        typeText: '',
        headPhoto: ''
      },
      rules: {
        radio: [{
          required: true
        }],
        platformCode: [{
          required: true
        }],
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        typeText: [{
          required: true,
          message: '请输入内容',
          trigger: 'blur'
        }],
        headPhoto: [{
          required: true,
          message: '请上传头图',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              console.log(pictureUrl);
              this.ruleForm.headPhoto = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    resetForm: function resetForm(formName) {
      // console.log()
      this.$refs[formName].resetFields();
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log(_this.ruleForm);
          var buffSend = {
            '1': _otherH5Page.savePageApi,
            '2': _otherH5Page.updatePageApi
          };
          var obj = {
            name: _this.ruleForm.name,
            platformCode: _this.ruleForm.platformCode,
            type: _this.ruleForm.radio,
            unionActId: _this.ruleForm.radio === 0 ? _this.ruleForm.typeText : '',
            unionActLink: _this.ruleForm.radio === 1 ? _this.ruleForm.typeText : '',
            mainImage: _this.ruleForm.headPhoto
          };
          if (_this.openType === '2') {
            obj['id'] = _this.id;
          }
          buffSend[_this.openType](obj).then(function (res) {
            if (res.data) {
              _this.$message({
                type: 'success',
                message: '操作成功'
              });
              _this.onClose();
              _this.$emit('refresh', {
                type: _this.openType
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    open: function open(val) {
      var _this2 = this;
      console.log(val, '=============');
      this.dialogVisible1 = true;
      this.$nextTick(function () {
        _this2.openType = val.openType;
        _this2.title = val.title;
        if (val.openType === '2') {
          _this2.id = val.id;
          _this2.ruleForm.platformCode = val.platformCode;
          _this2.ruleForm.name = val.name;
          _this2.ruleForm.radio = val.type;
          if (_this2.ruleForm.radio === 0) {
            _this2.ruleForm.typeText = val.unionActId;
          } else {
            _this2.ruleForm.typeText = val.unionActLink;
          }
          _this2.ruleForm.headPhoto = val.mainImage;
        }
      });
    },
    onClose: function onClose() {
      this.resetForm('ruleForm15');
      this.id = '';
      this.dialogVisible1 = false;
    }
  }
};